module.exports = __webpack_public_path__ + "img/tops-vhals.e7449016.png";